<template>
  <div class="hl-multi-select-label-container">
    <span
      v-if="label"
      :for="name"
      class="hl-multi-select-label block text-sm font-medium text-gray-700 mb-1"
      >{{ label }}
    </span>
    <multiselect
      class="hl-multi-select"
      :name="name"
      v-model="internalValue"
      :searchable="searchable"
      :options="options"
      :multiple="multiple"
      :close-on-select="closeOnSelect"
      :placeholder="placeholder"
      :allow-empty="allowEmpty"
      track-by="value"
      :label="$t('pmd.label')"
      :deselect-label="deselectLabel"
      :disabled="disabled"
      :loading="loading"
    >
      <template v-slot:noResult>
<span
        >{{ $t('pmd.uiComponents.noElementsFound') }}</span
      >
</template>
    </multiselect>
    <p v-if="description" class="mt-2 text-xs text-gray-500">
      {{ description }}
    </p>
    <p
      v-if="errorMsg && error"
      class="mt-2 text-sm text-red-600"
      id="email-error"
    >
      {{ errorMsg }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default defineComponent({
  components: {
    Multiselect,
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMsg: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [Object, Array, String, Number],
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Type to search',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    closeOnSelect: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    deselectLabel: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // Internal value to track the selected options
    const internalValue = ref(props.modelValue);

    // Watch for changes to the modelValue prop
    watch(() => props.modelValue, (newValue) => {
      // Only update internalValue if it's actually different
      if (JSON.stringify(internalValue.value) !== JSON.stringify(newValue)) {
        internalValue.value = newValue;
      }
    });

    // Watch internal value changes
    watch(internalValue, (newValue) => {
      // Only emit if the value has actually changed from the props
      if (JSON.stringify(props.modelValue) !== JSON.stringify(newValue)) {
        emit('update:modelValue', newValue);
      }
    });


    return {
      internalValue
    };
  }
})
</script>

<style>
input.multiselect__input:focus {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
  --tw-ring-color: none;
  --tw-ring-shadow: none;
}
</style>
